import React, { useContext } from 'react';
import CustomFieldRichText, { CustomFieldRichTextProps } from '../../custom-field-rich-text';
import { FIELD_TYPE_MAP, getStyleMap } from './constants';
import { PluginComponentContext } from '../plugin-component';

type PluginRichTextProps = Omit<CustomFieldRichTextProps, 'fieldTypeMap' | 'styleMap'>;

// Add interface for static properties
interface PluginRichTextStatic {
    getStyleMap: typeof getStyleMap;
    FIELD_TYPE_MAP: typeof FIELD_TYPE_MAP;
}

/**
 * 适配插件函数化的富文本编辑器
 *
 * @param props PluginRichTextProps
 * @class
 */
const PluginRichText: React.FC<PluginRichTextProps> & PluginRichTextStatic = (
    props: PluginRichTextProps
) => {
    const { value, isStatusError } = props;

    const pluginComponentStore = useContext(PluginComponentContext);
    const { checkStatusVisible, field } = pluginComponentStore || {};

    return (
        <CustomFieldRichText
            {...props}
            fieldTypeMap={FIELD_TYPE_MAP}
            styleMap={getStyleMap()}
            isStatusError={isStatusError || (checkStatusVisible && field?.isRequired && !value)}
        />
    );
};

PluginRichText.displayName = 'PluginRichText';
PluginRichText.getStyleMap = getStyleMap;
PluginRichText.FIELD_TYPE_MAP = FIELD_TYPE_MAP;

export default PluginRichText;
